/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useMutation, useQuery} from "@apollo/react-hooks";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {Select} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import {CREATE_INTRODUCTION, GET_INTRODUCTION, UPDATE_INTRODUCTION} from "../../database/queries/introductionQueries";
import {notify} from "../../utils/notify";
import FormHelperText from "@material-ui/core/FormHelperText";
import usePersistentStore from "../../persistentStore";
import {useHistory, useParams} from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {GET_CONTACTS_NAMES} from "../../database/queries/contactQueries";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import PageBar from "../Common/PageBar";
import {CREATE_WEB_HISTORY} from "../../database/queries/webHistoryQueries";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        '& p': {
            color: 'red',
        }
    },
    grow: {
        flexGrow: 1,
    },
    formControl: {
        'input': {
            '&::placeholder': {
                color: 'blue'
            }
        },
        '& .MuiFormLabel-root': {
            color: '#a0aec0'
        },
    },
    formControlError: {
        'input': {
            '&::placeholder': {
                color: 'red'
            }
        },
        '& .MuiFormLabel-root': {
            color: 'red'
        },
        '& .MuiInput-underline:before': {
            borderColor: 'red'
        },
    },
    gridContainer: {
        overflow: 'auto',
        padding: 10,
        border: '1px solid #d3d4d5'
    },
    typeField: {
        paddingRight: 20
    },
    statusField: {
        paddingLeft: 10,
        paddingRight: 10
    },
    priorityField: {
        paddingLeft: 30,
        paddingRight: 30
    },
    leftField: {
        paddingRight: 10
    },
    middleField: {
        paddingLeft: 10,
        paddingRight: 10
    },
    rightField: {
        paddingLeft: 10,
    },
    hidden: {
        display: 'none',
    },
    noMargin: {
        marginBottom: 0,
        minHeight: 0
    },
    shrink: {
        transform: 'translate(0, 1.5px) scale(0.75)',
        transformOrigin: 'top left',
    }
}));

const INITIAL_INTRODUCTION = {
    introductionId: null,
    introductionContactId: null,
    introductionContactName: null,
    introductionContactLinkedinId: '',
    introductionDirection: 'to',
    introductionNote: '',
};

const PopupIntroductionEdit = props => {
    const classes = useStyles();
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [introduction, setIntroduction] = useState({
        ...INITIAL_INTRODUCTION,
    });
    const [errors, setErrors] = useState({});
    const history = useHistory();
    const [autocompleteOpen, setAutocompleteOpen] = useState();
    const [autocompleteFilter, setAutocompleteFilter] = useState();
    const [autocompleteOptions, setAutocompleteOptions] = useState([]);
    const [target, setTarget] = useState({id: '', name: '', linkedinId: ''});
    let {introductionId} = useParams();

    const {loading: getIntroductionLoading, error: getIntroductionError, data: getIntroductionData} = useQuery(GET_INTRODUCTION, {
        skip: !introductionId || introductionId === 'new',
        variables: {introductionId: introductionId},
    });

    const {loading: getcontactsNamesLoading, refetch: getcontactsNamesRefetch} = useQuery(GET_CONTACTS_NAMES, {
        variables: {searchStr: autocompleteFilter, limit: 5},
    });

    const [updateIntroduction, {error: updateIntroductionError}] = useMutation(UPDATE_INTRODUCTION);
    const [createIntroduction, {error: createIntroductionError}] = useMutation(CREATE_INTRODUCTION);
    const [createWebHistory] = useMutation(CREATE_WEB_HISTORY);

    useEffect(() => {
        if (createIntroductionError) notify('createIntroductionError', 'error', createIntroductionError.message, null, null, globalPersistentState.popupQueryObj);
        if (getIntroductionError) notify('getIntroductionError', 'error', getIntroductionError.message, null, null, globalPersistentState.popupQueryObj);
        if (updateIntroductionError) notify('updateIntroductionError', 'error', updateIntroductionError.message, null, null, globalPersistentState.popupQueryObj);
    }, [createIntroductionError, getIntroductionError, updateIntroductionError]);

    useEffect(() => {
        if (getIntroductionData && getIntroductionData.introduction) {
            setIntroduction(getIntroductionData.introduction);
            setTarget({
                id: getIntroductionData.introduction.introductionId,
                name: getIntroductionData.introduction.introductionContactName,
                linkedinId: getIntroductionData.introduction.introductionContactLinkedinId,
            });
            if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
        }
    }, [getIntroductionData]);

    useEffect(() => {
        if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
    }, []);

    useEffect(() => {
        if (autocompleteFilter) {
            getcontactsNamesRefetch()
                .then((result) => {
                    let myContacts = [];
                    if (result.data && result.data.contactsNames) {
                        result.data.contactsNames.map(contact => myContacts.push({
                                id: contact.contactId,
                                name: contact.displayName,
                                linkedinId: contact.contactLinkedinId,
                            })
                        );
                    }
                    setAutocompleteOptions(myContacts);
                })
                .catch(e => {
                    console.trace(e);
                });
        }
    }, [autocompleteFilter, getcontactsNamesRefetch]);

    useEffect(() => {
        if (!autocompleteOpen) {
            setAutocompleteOptions([]);
        }
    }, [autocompleteOpen]);

    const changeIntroduction = (fields) => {
        let updatedIntroduction = {
            ...introduction,
            ...fields
        };
        setIntroduction(updatedIntroduction);
        if (!globalPersistentState.dirty) globalPersistentActions.setDirty(true);
    };

    const handleChange = (e) => {
        if (e.target) changeIntroduction({[e.target.name]: e.target.value});
    };

    // const contentCallback = useCallback(node => tellParentContentHeight(node, globalPersistentState.popupQueryObj), []);
    //
    // const onResize = (w, h) => {
    //     tellParentMessage({contentHeight: h}, globalPersistentState.popupQueryObj)
    // };

    const validateForm = () => {
        setErrors({});
        let newError = {};
        if (!introduction.introductionDirection) newError.introductionDirection = 'You must specify an intro direction';
        if (!introduction.introductionContactName || introduction.introductionContactName.length < 3) newError.introductionContactName = 'Please enter an introduction contact name that is at least 3 characters';

        if (Object.keys(newError).length > 0) {
            setErrors(newError);
            return false;
        } else {
            return true;
        }
    };

    if (getIntroductionLoading) return <p>Loading ...</p>;

    return (
        <div>
            <PageBar title={`Edit introduction ${props.editObj ? 'for ' + props.editObj.displayName : ''}`}/>
            <form className={classes.root}>
                {introduction && (<>
                    <Grid container className={classes.gridContainer}>
                        <Grid item xs={4} className={classes.leftField}>
                            <FormControl
                                className={errors.introductionDirection ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                                required
                            >
                                <InputLabel id="label-introduction-type">
                                    Introduction Direction
                                </InputLabel>
                                <Select
                                    required
                                    id="introductionDirection"
                                    name="introductionDirection"
                                    labelid="label-introduction-direction"
                                    fullWidth
                                    size="small"
                                    value={introduction.introductionDirection}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="to" id="introduction-direction-to">I introduced them to</MenuItem>
                                    <MenuItem value="by" id="introduction-direction-to">I was introduced by</MenuItem>
                                </Select>
                                <FormHelperText>
                                    {errors.introductionDirection}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <Autocomplete
                                    id="choose-contact"
                                    style={{width: '100%'}}
                                    freeSolo={true}
                                    selectOnFocus={true}
                                    open={autocompleteOpen}
                                    onOpen={() => {
                                        setAutocompleteOpen(true);
                                    }}
                                    onClose={() => {
                                        setAutocompleteOpen(false);
                                    }}

                                    onInputChange={(event, value, reason) => {
                                        changeIntroduction({
                                            introductionContactId: null,
                                            introductionContactName: value
                                        });
                                        setAutocompleteFilter(value);
                                    }}
                                    getOptionSelected={(option, value) => {
                                        return option.id === value.id
                                    }}
                                    getOptionLabel={option => {
                                        return option.name ? option.name + (option.linkedinId ? ' (' + option.linkedinId + ')' : '') : ''
                                    }}
                                    onChange={(event, value) => {
                                        if (value) {
                                            setTarget({
                                                id: value.id,
                                                name: value.name,
                                                linkedinId: value.linkedinId
                                            });
                                        } else {
                                            setTarget({id: '', name: '', linkedinId: ''});
                                        }
                                        changeIntroduction({
                                            introductionContactId: value ? value.id : '',
                                            introductionContactName: value ? value.name : '',
                                            introductionContactLinkedinId: value ? value.linkedinId : ''
                                        });
                                    }}
                                    options={autocompleteOptions}
                                    loading={getcontactsNamesLoading}
                                    value={target}
                                    renderInput={params => {
                                        return (
                                            <TextField
                                                {...params}
                                                label="Search contacts"
                                                variant="standard"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {getcontactsNamesLoading ?
                                                                <CircularProgress color="inherit"
                                                                                  size={20}/> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )
                                    }}
                                />
                                <FormHelperText>
                                    {errors.introductionContactName}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4} className={classes.rightField}>
                            <FormControl
                                className={errors.introductionContactLinkedinId ? classes.formControlError : classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="introductionContactLinkedinId"
                                    name="introductionContactLinkedinId"
                                    label="Linkedin Id"
                                    disabled={introduction.introductionContactId !== null}
                                    fullWidth
                                    size="small"
                                    onChange={handleChange}
                                    value={introduction.introductionContactLinkedinId ? introduction.introductionContactLinkedinId : ''}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl
                                className={classes.formControl}
                                margin="dense"
                                size="small"
                                fullWidth
                            >
                                <TextField
                                    id="introductionNote"
                                    name="introductionNote"
                                    label="Introduction note"
                                    fullWidth
                                    size="small"
                                    multiline
                                    rowsMax="3"
                                    value={introduction.introductionNote ? introduction.introductionNote : ''}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.gridContainer}>
                        <Grid item xs={6} className={classes.leftField}>
                            <Button
                                id={"btn-cancel"}
                                fullWidth={true}
                                variant="contained"
                                onClick={() => {
                                    console.log('## SVR popupIntroductionEdit ## changing history', '/popup/contact/' + props.editId + '/introductions');
                                    history.push('/popup/contact/' + props.editId + '/introductions');
                                    props.parentRefresh();
                                }}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item xs={6} className={classes.rightField}>
                            <Button
                                id={"btn-save"}
                                fullWidth={true}
                                variant="contained"
                                color="primary"
                                disabled={!globalPersistentState.dirty}
                                onClick={() => {
                                    if (validateForm()) {
                                        if (introduction.introductionId && introduction.introductionId !== 'new') {
                                            updateIntroduction({
                                                variables: {
                                                    changedIntroduction: {
                                                        introductionId: introduction.introductionId,
                                                        contactId: props.editId,
                                                        introductionContactId: introduction.introductionContactId,
                                                        introductionContactName: introduction.introductionContactName,
                                                        introductionContactLinkedinId: introduction.introductionContactLinkedinId,
                                                        introductionDirection: introduction.introductionDirection,
                                                        introductionNote: introduction.introductionNote,
                                                    }
                                                }
                                            }).then(async (updateResult) => {
                                                if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                    await createWebHistory({
                                                        variables: {
                                                            newWebHistory: {
                                                                parentType: 'introduction',
                                                                parentId: introduction.introductionId,
                                                                url: globalPersistentState.popupQueryObj.selectionUrl
                                                            }
                                                        }
                                                    })
                                                }
                                                notify('updateIntroduction', 'info', 'Introduction updated', null, null, globalPersistentState.popupQueryObj);
                                                if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                                console.log('## SVR popupIntroductionEdit ## changing history', '/popup/contact/' + props.editId + '/introductions');
                                                history.push('/popup/contact/' + props.editId + '/introductions');
                                                props.parentRefresh();
                                            }).catch(e => {
                                                notify('updateIntroduction', 'error', 'Problem updating introduction', null, null, globalPersistentState.popupQueryObj);
                                            })
                                        } else {
                                            createIntroduction({
                                                variables: {
                                                    newIntroduction: {
                                                        contactId: props.editId,
                                                        introductionContactId: introduction.introductionContactId,
                                                        introductionContactName: introduction.introductionContactName,
                                                        introductionContactLinkedinId: introduction.introductionContactLinkedinId,
                                                        introductionDirection: introduction.introductionDirection,
                                                        introductionNote: introduction.introductionNote,
                                                    }
                                                }
                                            }).then(async (createResult) => {
                                                if (globalPersistentState.popupQueryObj && globalPersistentState.popupQueryObj.selectionUrl) {
                                                    await createWebHistory({
                                                        variables: {
                                                            newWebHistory: {
                                                                parentType: 'introduction',
                                                                parentId: createResult.data.createIntroduction.id,
                                                                url: globalPersistentState.popupQueryObj.selectionUrl
                                                            }
                                                        }
                                                    })
                                                }
                                                notify('createIntroduction', 'info', 'Introduction created', null, null, globalPersistentState.popupQueryObj);
                                                if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                                console.log('## SVR popupIntroductionEdit ## changing history', '/popup/contact/' + props.editId + '/introductions');
                                                history.push('/popup/contact/' + props.editId + '/introductions');
                                                props.parentRefresh();
                                            }).catch(e => {
                                                notify('createIntroduction', 'error', 'Problem creating introduction', null, null, globalPersistentState.popupQueryObj);
                                            })
                                        }
                                    }
                                }}
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </>)}
            </form>
        </div>
    )
};

export default PopupIntroductionEdit
